export const IGNORED_SENTRY_ERRORS = [];
export const getIgnoredErrorPatterns = () => IGNORED_SENTRY_ERRORS.map(entry => entry.pattern);
//# sourceMappingURL=sentry-ignored-errors.js.map